import rootReducer from "./reducers";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { createStore, applyMiddleware } from "redux";
import promiseMiddleware from "redux-promise";
// npm install redux-persist-transform-filter
const persistConfig = {
  key: "root",
  storage,
  blacklist: ["tasks", "workTeams", "reload"],
};
const createStoreWithMW = applyMiddleware(promiseMiddleware)(createStore);
const persistedReducer = persistReducer(persistConfig, rootReducer);
export const store = createStoreWithMW(persistedReducer);
export const persistor = persistStore(store);
